export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatId: "RO 35671874",
        regCom: "J2016000468359",
        address1: "Strada Caprioarei 11",
        address2: "307200 Ghiroda, Kreis Timis, Rumänien",
        bankName: "Banca Transilvania",
        ibanNo: "RO89 BTRL EURC RT03 3757 8301",
        vatRate: "21%",
        validDays: "5"
    },
    dateFormat: "dd.MM.yyyy",
    labels: {
        proforma: "Proforma-Rechnung",
        proformaValidity: "Gültigkeit der Proforma-Rechnung",
        days: "Tage",
        from: "vom",
        piece: "St.",
        vatId: "USt-IdNr",
        regCom: "Handelsregisternummer",
        bank: "Bank",
        iban: "IBAN",
        client: "Kunde",
        mrMrs: "Herr/Frau",
        email: "E-Mail",
        phone: "Tel",
        vatRate: "MwSt-Satz",
        vatFree: "MwSt-frei",
        downPayment: "Anzahlung",
        accordingToOfferNo: "gemäß Angebot Nr.",
        no: "Nr",
        productName: "Produktbezeichnung",
        qty: "Menge",
        onePrice: "Einzelpreis",
        netAmount: "Nettobetrag",
        subtotal: "Zwischensumme",
        woVat: "ohne MwSt",
        vat: "MwSt",
        total: "Gesamtbetrag",
        note1: "* Reverse Charge",
        note2: "Verlagerung der Steuerschuld"
    }
}